import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { CardLayoutComponent } from './card-layout.component';

@NgModule({
   declarations: [CardLayoutComponent],
   imports: [CommonModule, MatCardModule],
   exports: [CardLayoutComponent],
})
export class CardLayoutModule {}
